import { IconSvg, IconSvgProps, IconSvgSizes } from ".";
import React from "react";
import { ComponentInterfaceBaseClass } from "@att-bit/duc.utils-ts.types";

export class IconSvgInterface
  extends ComponentInterfaceBaseClass
  implements IconSvgProps
{
  svgNodeStr?: string;
  svgUrl?: string;
  imgUrl?: string;
  size?: IconSvgSizes;
  color?: string;
  accentColor?: boolean;
  altText?:string;
  'aria-hidden'?: boolean;

  static initWithSanity(key, feed) {
    const t = new IconSvgInterface();    
    let isSvgStr;   
    const isSvg = (feed.icon?.includes('svg')) ? true :  false;
    if(isSvg){
      isSvgStr = feed.icon?.includes('<svg') ? true : false;
    }
    t.svgNodeStr = isSvgStr ? feed?.icon : undefined;
    t.svgUrl = !isSvgStr? feed?.icon : undefined;
    t.imgUrl = !isSvg ? feed?.icon: undefined;
    t.size = feed.configs?.size ? IconSvgSizes[String(feed.configs?.size).toUpperCase()] : IconSvgSizes.LG;
    t.color = feed.configs?.color;
    t.accentColor = feed.configs?.accentColor;
    if(feed?.altText)
    {
    t.altText = feed?.altText;
    }
    if (feed?.['aria-hidden'] && feed['aria-hidden'] == true) {
      t['aria-hidden'] = true;
    }
    return t;
  }

  toProps(): IconSvgProps {
    const props = {
      svgNodeStr: this.svgNodeStr,
      svgUrl: this.svgUrl,
      imgUrl: this.imgUrl,
      size: this.size,
      color: this.color,
      accentColor: this.accentColor,
      altText:this.altText,
      ...(this['aria-hidden'] === true && {'aria-hidden':true})
    };
    return props;
  }

  toJsx(): JSX.Element {
    return React.createElement(IconSvg, {
      ...this.toProps(),
    });
  }
}